// language=GraphQL
export const ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY = `query Query {
  travelDocumentationServices: allTravelDocumentationServices {
    id
    printServiceNo
    electronicServiceNo
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY = `query Query($id: ID!) {
  travelDocumentationServices: travelDocumentationServices(id: $id) {
    id
    printServiceNo
    electronicServiceNo
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = `
  mutation Mutation($input: CreateTravelDocumentationServicesInput) {
    travelDocumentationServices: createTravelDocumentationServices(input: $input) {
      id
      printServiceNo
      electronicServiceNo
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = `
  mutation Mutation($input: UpdateTravelDocumentationServicesInput) {
    travelDocumentationServices: updateTravelDocumentationServices(input: $input) {
      id
      printServiceNo
      electronicServiceNo
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = `
  mutation Mutation($input: DeleteTravelDocumentationServicesInput) {
    deleteTravelDocumentationServices(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = `
  mutation Mutation($input: DeleteTravelDocumentationServicesInput) {
    forceDeleteTravelDocumentationServices(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TRAVEL_DOCUMENTATION_SERVICES_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioConfigs: Boolean = false) {
  groupedDependents: travelDocumentationServicesDependents(id: $id) {
    ratioConfigs @include(if: $withRatioConfigs) {
      id
    }
  }
}`
